export const withoutExpiresAt = (settings = {}) => {
  const { expiresAt, ...rest } = settings;
  return rest;
};

export const withResetExpiresAt = (settings = {}) => ({
  ...withoutExpiresAt(settings),
  expiresAt: '',
});

const normalizePresetSettings = (presetSettings = {}) => ({
  ...withoutExpiresAt(presetSettings),
  notProofingDescriptionShow: presetSettings.notProofingDescriptionShow ?? true,
  notProofingTitleShow: presetSettings.notProofingTitleShow ?? true,
});

export default normalizePresetSettings;
